@if (product$ | async; as product) {
  <div class="container">
    @for (referenceType of product?.productReferencesTab; track referenceType; let last = $last) {
      <div class="type">
        <h4>{{ "product.referenceTypes." + referenceType.referenceType | cxTranslate }}</h4>
        @for (group of referenceType.accessoryGroups; track group; let last = $last) {
          <div class="group">
            <h5>{{ group.name }}</h5>
            <div class="references-items-container">
              @for (reference of group.references; track reference) {
                <span class="item reference-container"
            [routerLink]="
            {
              cxRoute: 'product',
              params: { code: reference.target.code }
            } | cxUrl
          ">
                  <cx-media [container]="reference.target.images" format="product"> </cx-media>
                  <div class="name">
                    {{ reference.target.name }}
                  </div>
                  @if (reference.target.ekPrice) {
                    <div class="price">
                      {{ 'productDetails.ekPrice' | cxTranslate }} {{ reference.target.ekPrice.formattedValue }}
                    </div>
                  }
                </span>
              }
            </div>
            @if (!last) {
              <div>
                <hr>
                </div>
              }
            </div>
          }
          @if (!last) {
            <hr>
            }
          </div>
        }
      </div>
    }
